
import { Popover } from "ant-design-vue"
const { ...other } = Popover
const YwPopover = {
	...other,
	name:"YwPopover"
};

YwPopover.install = function (Vue) {
	Vue.component(YwPopover.name, YwPopover);
};

export default YwPopover;
